<template>
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <PageTitle v-bind:title="title" v-bind:admin="false" />
        <ErrorMessage
            v-if="errors"
            :error="errors"
            class="max-w-sm mx-auto"
        />
        <loader v-if="loading" />
        <div v-else class="mt-9">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                    <tr>
                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Пользователь
                        </th>
                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Пройденные курсы
                        </th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="u in data" v-bind:key="u.id">
                        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500">
                            <p class="text-sm font-medium text-blue-500">
                                <router-link :to="{ name: 'user_show', params: { id: u.id } }" class="hover:underline">
                                    {{ u.name }}
                                </router-link>
                            </p>
                        </td>
                        <td class="px-6 py-4 text-sm text-gray-900">
                            <ul style="list-style-type: disc">
                                <li v-for="c in u.courses_done" v-bind:key="c.id">
                                    <p class="text-sm font-medium text-blue-700">
                                        <router-link :to="{ name: 'course_show', params: { id: c.id } }" class="hover:underline">
                                            {{ c.name }}
                                        </router-link>
                                    </p>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
import Loader from "@/components/Loader";
import axios from "axios";
import ErrorMessage from "@/components/ErrorMessage";
export default {
    data() {
        return {
            title: 'Учащиеся',
            data: null,
            loading: true,
            errors: '',
        }
    },
    components: {
        PageTitle,
        Loader,
        ErrorMessage,
    },
    mounted() {
        this.loadRecords()
    },
    methods: {
        async loadRecords() {
            this.errors = "";
            try {
                this.loading = true;
                let response = await axios.get("students");
                this.data = response.data.users;
                this.loading = false;
            } catch (e) {
                this.errors = "Ошибка при загрузке данных";
            }
        },
    },
}
</script>